import './style.scss';

const SkipLinkHome = () => {
    const handleKeyDown = (event) => {
        const items = document.querySelectorAll('.br-skiplink .br-item');
        const currentIndex = Array.from(items).indexOf(document.activeElement);

        switch (event.key) {
            case 'ArrowDown':
            case 'ArrowRight':
                event.preventDefault();
                const nextIndex = (currentIndex + 1) % items.length;
                items[nextIndex].focus();
                break;

            case 'ArrowUp':
            case 'ArrowLeft':
                event.preventDefault();
                const prevIndex = (currentIndex - 1 + items.length) % items.length;
                items[prevIndex].focus();
                break;

            case 'Home':
                event.preventDefault();
                items[0].focus();
                break;

            case 'End':
                event.preventDefault();
                items[items.length - 1].focus();
                break;

            case 'Enter':
            case ' ':
                event.preventDefault();
                document.activeElement.click();
                break;

            default:
                break;
        }
    };

    return (
        <>
            <header aria-label='cabeçalho dos links de navegação rápida'>
                <nav
                    className="br-skiplink full"
                    aria-label='links de navegação rápida'
                    onKeyDown={handleKeyDown}
                >
                    <a
                        className="br-item"
                        href="#main-content"
                        tabIndex="1"
                        accessKey="1"
                    >
                        Ir para o conteúdo <span aria-hidden="true" className="br-tag text ml-1">1</span>
                    </a>
                    <a
                        className="br-item"
                        href="#menu"
                        tabIndex="1"
                        accessKey="2"
                    >
                        Ir para o menu <span aria-hidden="true" className="br-tag text ml-1">2</span>
                    </a>
                    <a
                        className="br-item"
                        href="#busca"
                        tabIndex="1"
                        accessKey="3"
                    >
                        Ir para a busca <span aria-hidden="true" className="br-tag text ml-1">3</span>
                    </a>
                    <a
                        className="br-item"
                        href="#footer"
                        tabIndex="1"
                        accessKey="4"
                    >
                        Ir para o rodapé <span aria-hidden="true" className="br-tag text ml-1">4</span>
                    </a>
                </nav>
            </header>
        </>
    );
};

export default SkipLinkHome;